import React from 'react';
import ReactDOM from 'react-dom';
import { AlertCircle } from 'lucide-react';

import { 
  ModalOverlay, 
  ModalWrapper, 
  ModalIcon,
  ModalTitle,
  ModalMessage,
  ModalFooter,
  Button
} from './style';

interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: string | React.ReactNode;
  actions: {
    label: string;
    onClick: () => void;
    variant: 'primary' | 'outline' | 'danger' | 'danger-outline';
  }[];
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ isOpen, title, message, actions }) => {
  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <ModalOverlay>
      <ModalWrapper>
        <ModalIcon>
          <AlertCircle size={48} />
        </ModalIcon>
        <ModalTitle>{title}</ModalTitle>
        <ModalMessage>{message}</ModalMessage>
        <ModalFooter>
          {actions.map((action, index) => (
            <Button key={index} onClick={action.onClick} variant={action.variant}>
              {action.label}
            </Button>
          ))}
        </ModalFooter>
      </ModalWrapper>
    </ModalOverlay>,
    document.body
  );
};

export default ConfirmationModal;
